export default __webpack_public_path__ + "static/media/password-manager-1.9919235a.png";